import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Flex, RectangularButton } from '@resideo/blueprint-react';
import ModalHeader from 'components/common/ModalHeader';

export const RequestMyDataErrorModal = ({
  message,
  onCancel,
}: {
  message: string;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader
        title={t('privacy.requestMyData.configuration.title')}
        textAlign='center'
        closeModal={onCancel}
      />
      <Text
        data-test-request-my-data-error-modal-text
        textAlign='center'
        marginBottom='small'
        paddingBottom={'medium'}
        justifyContent='center'>
        {message}
      </Text>
      <Flex flexDirection='column'>
        <RectangularButton
          data-test-request-my-data-error-modal-close-button
          type='button'
          variant='secondary'
          onClick={onCancel}>
          {t('common.close')}
        </RectangularButton>
      </Flex>
    </>
  );
};
